'use client';

import React from 'react';
import classNames from 'classnames';
import { ApplyButton as GateApplyButton } from '@gate-js/react';
import { IconPickerItem } from 'react-icons-picker/src';
import parse from 'html-react-parser';
import { getLinkClasses, getLinkStyle } from '../selectors/Link/Link';
import { Text } from '../selectors/Text/Text';
import Flag from '../static/Flag';
import Icon from '../selectors/Link/Icon';
import { processDocuments } from '../../utils/documents';

export default function ApplyButton(props) {
	const { settings, text, textComponent, iconBefore, textCenter, options, documents, global, jobLanguage, active = false } = props;

	if (!active) {
		return (
			<button
				style={getLinkStyle(props, settings)}
				className={classNames(
					'not-prose',
					getLinkClasses(props, settings),
					textCenter ? 'block' : 'inline-flex',
					'hover:opacity-75',
				)}
			>
				<div className="inline-flex items-center align-middle text-center gap-x-2">
					{iconBefore && (iconBefore.length === 2 ? <Flag code={iconBefore} /> : <Icon value={iconBefore} />)}
					{parse(text)}
				</div>
			</button>
		);
	}

	return (

		<GateApplyButton
			global={global}
			initialOpen={props.initialOpen}
			options={{
				parse: settings?.parse !== 'false',
				fields: { salutation: settings?.salutation !== 'false' },
				language: jobLanguage ?? settings.language ?? 'en',
				addons: processDocuments(documents, global),
				...options,
			}}
			style={getLinkStyle(props, settings)}
			className={classNames(
				'not-prose',
				getLinkClasses(props, settings),
				textCenter ? 'block' : 'inline-flex',
				'hover:opacity-75',
			)}
		>
			<div className="inline-flex items-center align-middle text-center gap-x-2">
				{iconBefore && (iconBefore.length === 2 ? <Flag code={iconBefore} /> : (
					<IconPickerItem value={iconBefore} />))}
				<Text {...textComponent} text={text} />
			</div>
		</GateApplyButton>
	);
}
